import { AxiosResponse } from "axios";
import { AuditTrails } from "./Types";

export const mapAuditTrailsRequests =
(resp: AxiosResponse): AuditTrails => resp.data as AuditTrails;
